export default "__VITE_ASSET__BQZD1bm7__"